import React, { Component } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import BoothDetail from "./BoothDetail";


library.add(faPlusCircle);

class BoothList extends Component {
  constructor(props) {
    super(props);
    this.state = {
       ...props
    }
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.getDb !== prevState.getDb) {
      // console.log('Derived State From Props');
      // console.log(this.state.boothList);
      return { getDb: nextProps.getDb };
    }
    return null; // null 을 리턴하면 따로 업데이트 할 것은 없다라는 의미
  }

  render() {
    if (this.state.getDb) {
      const { boothList } = this.state;
      const boothDetails = boothList.map((booth)=>{
        const { boothId } = booth;
        return <BoothDetail key={boothId} info={booth} />;
      })

      return(
        <div className="booth-list">
          <Link to="/upload" className="booth-detail">
            <div className="info">
              <div><FontAwesomeIcon icon="plus-circle" /> 대잔치 개최하기</div>
            </div>
          </Link>
          {boothDetails}
        </div>
      );
    }
    else {
      return (
        <div>loading</div>
      );
    }
  }
}
export default BoothList;